<template>
  <app-layout>
    <b-navbar toggleable="sm" class="my-3 pl-0">
      <b-navbar-toggle target="subnav"></b-navbar-toggle>
      <b-navbar-brand href="#">
        <h1 class="h3">{{ $t("telegestion-title") }}</h1>
      </b-navbar-brand>
      <b-collapse is-nav id="subnav" class="c-subnav">
        <b-navbar-nav v-b-scrollspy class="ml-auto">
          <b-nav-item href="#telepointages">{{
            $t("telepointages-title")
          }}</b-nav-item>
          <b-nav-item href="#mon-qr-code">{{
            $t("documents-my-qr-code-title")
          }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <vita-telepointages
      :sectionTitle="$t('telepointages-title')"
      class="mb-5"
    ></vita-telepointages>
    <vita-telegestion
      :sectionTitle="$t('documents-my-qr-code-title')"
    ></vita-telegestion>
  </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import VitaTelegestion from "../Documents/Telegestion/Telegestion.vue";
import VitaTelepointages from "./Telepointages/Telepointages.vue";

export default {
  name: "Telegestion",
  components: {
    AppLayout,
    VitaTelegestion,
    VitaTelepointages
  }
};
</script>
